(function() {
    angular
        .module("app")
        .controller("DeleteMessageModalController", DeleteMessageModalController)

    DeleteMessageModalController.$inject = [
        "$scope",
        "$uibModalInstance",
        "messagesService",
        "userMessagingService",
        "messageBoardID",
        "messageID",
        "messageName",
        "hasAssociatedEvents"
    ]

    function DeleteMessageModalController(
        $scope,
        $uibModalInstance,
        messagesService,
        userMessagingService,
        messageBoardID,
        messageID,
        messageName,
        hasAssociatedEvents
    ){
        "use strict"

        $scope.messageBoard = {
            id: messageBoardID
        }

        $scope.message = {
            id:                  messageID,
            name:                messageName,
            hasAssociatedEvents: hasAssociatedEvents
        }

        $scope.deleteMessage = function() {
            $uibModalInstance.close(
                messagesService.deleteMessage(
                    messageBoardID,
                    messageID,
                    function() {
                        //Success
                        userMessagingService.success("Message Deletion Request Sent")
                    },
                    function(error) {
                        //Failure
                        userMessagingService.error(error)
                    }
                )
            )
        }

        $scope.cancel = function() {
            $uibModalInstance.dismiss("cancel")
        }
    }
})()
